import axios from 'axios'

export default class ChatService {
  constructor(chatAppUrl) {
    this.chatAppUrl = chatAppUrl
  }

  async getAvailableAgentForDealer(dealerId) {
    const agents = await axios.get(`${this.chatAppUrl}/agents/dealer/${dealerId}`)

    return agents.data
  }

  async getUserToken(email = '') {
    const userTokenResponse = await axios.post(`${this.chatAppUrl}/token`, {
      email,
    })

    return userTokenResponse.data
  }

  async createConversation(dealerId, adId, adUrl, realmId = null) {
    const data = {
      dealerId,
      adId,
      friendlyName: adUrl,
      adUrl,
    }

    if (realmId) {
      data['realmId'] = realmId
    }

    const conversationResponse = await axios.post(`${this.chatAppUrl}/conversations`, data)
    return conversationResponse.data
  }

  async startConversation(postBody, conversationId) {
    const conversationResponse = await axios.post(`${this.chatAppUrl}/conversations/${conversationId}/start`, postBody)
    return conversationResponse.data
  }

  async createLead(postBody) {
    axios.post(`${this.chatAppUrl}/leads`, postBody)
  }

  async customerWindowClosed(conversationId) {
    axios.post(`${this.chatAppUrl}/conversations/${conversationId}/customerWindowClosed`)
  }
}
